"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const content_1 = require("@prismicio/types-internal/lib/content");
const ImageLinkRenderer = (ctx) => ({
    renderV1(link, _fetch, options) {
        return {
            type: "Link.image",
            value: {
                ...(!(options === null || options === void 0 ? void 0 : options.omitKey) && { key: link.key }),
                image: {
                    kind: link.value.kind,
                    ...(content_1.FilledImageLinkContent.is(link.value) && {
                        id: link.value.id,
                        url: ctx.urlRewriter.optimizeImageUrl(link.value.url),
                        name: link.value.name,
                        size: link.value.size,
                        width: link.value.width,
                        height: link.value.height,
                    }),
                    ...(link.value.text && { text: link.value.text }),
                    ...(link.value.variant && { variant: link.value.variant }),
                },
            },
        };
    },
    renderV2(def, link, _fetch, options) {
        const defVariants = def.variants || [];
        const linkVariant = link.value.variant && defVariants.includes(link.value.variant) ? link.value.variant : defVariants[0];
        return {
            link_type: "Media",
            ...(!(options === null || options === void 0 ? void 0 : options.omitKey) && { key: link.key }),
            kind: link.value.kind,
            ...(content_1.FilledImageLinkContent.is(link.value) && {
                id: link.value.id,
                url: ctx.urlRewriter.optimizeImageUrl(link.value.url),
                name: link.value.name,
                size: link.value.size,
                width: link.value.width,
                height: link.value.height,
            }),
            ...(def.allowText && link.value.text && { text: link.value.text }),
            ...(linkVariant && { variant: linkVariant }),
        };
    },
    renderMocks(def, link, options) {
        return this.renderV2(def, link, undefined, options);
    },
});
exports.default = ImageLinkRenderer;
